<h3-layer-view-settings-popover>
  <ng-container projection-location="sliders">
    <strong class="sub-header">Shapes</strong>
    <h3-objectless-view-settings-opacity-slider
      [defaultLayerOpacity]="defaultLayerOpacity"
    ></h3-objectless-view-settings-opacity-slider>
    <div *ngIf="!isOrthographic">
      <strong class="sub-header">Image</strong>
      <div class="popover-grid form-group">
        <h3-view-settings-brightness-slider></h3-view-settings-brightness-slider>
        <h3-view-settings-contrast-slider></h3-view-settings-contrast-slider>
      </div>
    </div>
  </ng-container>

  <ng-container projection-location="options">
    <h3-checkbox
      *ngIf="isRectangleToolAllowed"
      [nasModel]="showShapeDimensionsStore"
      (change)="trackShowDimensionsChange()"
    >
      Show dimensions inside rectangles
    </h3-checkbox>
    <h3-checkbox
      [nasModel]="hideOccludedShapesStore"
      (change)="trackHideOccludedShapesChange()"
    >
      Hide occluded shapes
    </h3-checkbox>
    <h3-checkbox [nasModel]="alwaysShowSubpointsStore">
      Always show subpoints
    </h3-checkbox>
    <h3-checkbox [nasModel]="swapLayerOnSelectStore">
      Swap layer on select
    </h3-checkbox>
    <h3-zoom-panel-settings></h3-zoom-panel-settings>
  </ng-container>
</h3-layer-view-settings-popover>
